import { render, staticRenderFns } from "./BaseCatalog.vue?vue&type=template&id=223984f6&scoped=true&"
import script from "./BaseCatalog.vue?vue&type=script&lang=js&"
export * from "./BaseCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223984f6",
  null
  
)

export default component.exports